import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { WeightAndSizeModalComponent } from './weight-and-size-modal.component';

@NgModule({
  declarations: [WeightAndSizeModalComponent],
  imports: [CommonModule, FormsModule, NgxBootstrapIconsModule],
  exports: [WeightAndSizeModalComponent],
})
export class WeightAndSizeModalModule {}
